<template>
    <div class="custom-work-option">
        <h2>{{ option.name }}</h2>
        <div class="price">{{ formats.currency(option.price) }}</div>
        <ul>
            <li v-for="benefit in option.benefits" :key="benefit">{{ benefit }}</li>
        </ul>
        <button class="primary" @click="packageSelected()">
            {{ option.name }} <i class="material-icons">chevron_right</i>
        </button>
    </div>
</template>
<script>
import { formatCurrency as currency } from '@/utils/format'

export default {
    data() {
        return {
            formats: {
                currency(value) {
                    return currency(value, { maximumFractionDigits: 0 })
                },
            },
        }
    },
    props: {
        option: {
            type: Object,
            required: true,
        },
    },
    methods: {
        packageSelected() {
            this.$emit('packageSelected', this.option)
        },
    },
}
</script>
<style>
.custom-work-option {
    display: flex;
    flex-direction: column;
    padding: 24px;

    h2 {
        margin-bottom: 16px;
    }

    ul {
        flex-grow: 1;
        margin-bottom: 40px;

        li {
            margin-bottom: 8px;
            list-style-type: disc;
        }
    }

    button .material-icons {
        float: right;
    }

    .price {
        font-size: 18px;
        padding: 16px;
        text-align: right;
    }
}
</style>
